module.exports = __webpack_public_path__ + "img/check-moonstake.1f4bb996.svg";